import axios from "axios";
import ConstantList from "app/appConfig";

const API_PATH = ConstantList.API_EN_POINT_CRM + "/referral-partner";

export const pagingReferralPartner = (dto) => {
  const url = API_PATH + "/paging";
  return axios.post (url, dto);
};

export const getReferralPartnerById = (id) => {
  const url = API_PATH + "/" + id;
  return axios.get (url);
};